function brokerbayFocusOnClick() {
  return {
    restrict: 'A',
    controller: function focusOnClickController() {},
  };
}

function brokerbayFocusOnClickButton() {
  return {
    restrict: 'A',
    require: '^^brokerbayFocusOnClick',
    link: (scope, elem, attr, ctrl) => {
      elem.on('click', () => {
        ctrl.focus();
      });
    },
  };
}

function brokerbayFocusOnClickElement() {
  return {
    restrict: 'A',
    require: '^^brokerbayFocusOnClick',
    link: (scope, elem, attr, ctrl) => {
      ctrl.focus = () => {
        elem.focus();
      };
    },
  };
}

export {
  brokerbayFocusOnClick,
  brokerbayFocusOnClickButton,
  brokerbayFocusOnClickElement,
};
